import React, { useState } from "react";
import { Box, Slide, CircularProgress } from "@mui/material";

export const ImageWithSkeleton = ({ imageUrl, altText, height, width, animationDuration, slideTo, slidingKey, ...rest }) => {
    const [isLoaded, setIsLoaded] = useState(false);

    const handleImageLoad = () => {
        setIsLoaded(true);
    };

    return (
        <>
            {!isLoaded && (
                <Box flexGrow={1} display="flex" alignItems="center" justifyContent="center">
                    <CircularProgress />
                </Box>
            )}

            <Slide
                in={true}
                direction={slideTo}
                timeout={800}
                mountOnEnter
                unmountOnExit
                key={slidingKey}
            >
                <img
                    src={imageUrl}
                    alt={altText}
                    onLoad={handleImageLoad}
                    {...rest}
                    height={height}
                    width={width}
                />
            </Slide>
        </>
    );
};
